import { useChatStore } from "../Store";
import { FileTypes } from "@/Modules/Chat/Models/Domain/Chat";

import { getFileSrc } from "@/Services/TherapyApi/Chat";

const DownloadFileActionHandler = async (url: string, type: FileTypes, eventId?: string): Promise<string> => {
  const chatStore = useChatStore();
  const fileSrc = await getFileSrc(url);

  if (type === FileTypes.IMAGE) {
    chatStore.imageSrc = fileSrc.src_url;
    chatStore.openImagePreview = true;
  }

  if (type === FileTypes.AUDIO && eventId) {
    chatStore.audioFiles[eventId] = fileSrc.src_url;
  }

  return fileSrc.src_url;
};

export default DownloadFileActionHandler;
